import { render, staticRenderFns } from "./all-setting.vue?vue&type=template&id=6077061c&"
import script from "./all-setting.vue?vue&type=script&lang=js&"
export * from "./all-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports